<script>
  import { Col, Container, Row } from 'sveltestrap';
  export let compressed = false;
  export let bgcolor = 'none';
  export let bgimage = "";
  export let smallSidebar = false;
  export let hideLeftOnSmall = false;
  export let fullCover = false;
  let background_image = "";

  if ( bgimage != "" ) {
    background_image = "--bgimage: url(/" + bgimage + ");";
  }
</script>

<style>
  .left {
    height: 100%;
    background-color: var(--palette-pop-a);
    color: var(--palette-white);
    padding-top: 25px;
    padding-bottom: 25px;
    transition: all 0.3s;
    text-align: left;
    padding-left: 25px;
  }

  .right {
    padding-top: 25px;
    padding-bottom: 25px;
    transition: all 0.3s;
    color: var(--palette-white);
    height: 100%;
    width: 100%;
  }

  .compressed {
    padding-top: 3px;
    padding-bottom: 0px;
  }

  .fullCover {
    height: 100vh;
  }

  .outer {
    width: 100%;
    /* background-color: var(--bgcolor); */
    background-image: var(--bgimage);
    position: relative;
  }

  .outer::before {
    background-color: var(--bgcolor);
    content: "";
    position: absolute;
    left: 0; right: 0;
    top: 0; bottom: 0;
  }

  @media screen and (max-width:767px) {
    :global(.hide) {
      display: none;
    }
  }
</style>

<div class="outer" style="--bgcolor: {bgcolor}; {background_image};">
  <Container>
    <Row>
      <Col lg="3" xs="{smallSidebar ? '6': '12'}" md="4" class="{hideLeftOnSmall ? 'hide': ''}">
        <div class="left {compressed ? 'compressed': ''}">
          <slot name="left">
            Left
          </slot>
        </div>
      </Col>
      <Col lg="9" xs="{smallSidebar ? '6': '12'}" md="8">
        <div class="right {compressed ? 'compressed': ''} {fullCover ? 'fullCover': ''}">
          <slot name="right">
            Right
          </slot>
        </div>
      </Col>
    </Row>
  </Container>
</div>
